// Backend API Configuration
export const BACKEND_CONFIG = {
  // Base API URL - change this to match your backend
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api',
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      ME: '/auth/me',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      CHANGE_PASSWORD: '/auth/change-password',
      UPDATE_PROFILE: '/auth/profile',
      UPLOAD_AVATAR: '/auth/avatar',
    },
    
    // Firms
    FIRMS: {
      LIST: '/firms',
      GET: '/firms/{id}',
      CREATE: '/firms',
      UPDATE: '/firms/{id}',
      DELETE: '/firms/{id}',
      STATISTICS: '/dashboard/firm-statistics',
      SETTINGS : {
        LOGO: '/settings/firm/logo',
        PROFILE: '/settings/profile',
      }
    },
    
    // Cases
    CASES: {
      LIST: '/cases',
      CREATE: '/cases',
      GET: '/cases/:id',
      UPDATE: '/cases/:id',
      DELETE: '/cases/:id',
      ACTIVITY: '/cases/:id/activity',
      BILLING: '/cases/:id/billing',
    },
    
    // Clients
    CLIENTS: {
      LIST: '/clients',
      CREATE: '/clients',
      GET: '/clients/:id',
      UPDATE: '/clients/:id',
      DELETE: '/clients/:id',
    },
    
    // Documents
    DOCUMENTS: {
      LIST: '/documents',
      UPLOAD: '/documents',
      GET: '/documents/:id',
      UPDATE: '/documents/:id',
      DELETE: '/documents/:id',
      MOVE: '/documents/:id/move',
      SHARE: '/documents/:id/share',
      FOLDERS: {
        LIST: '/documents/folders',
        CREATE: '/documents/folders',
        GET: '/documents/folders/:id',
        UPDATE: '/documents/folders/:id',
        DELETE: '/documents/folders/:id',
      },
    },
    
    // Chat
    CHAT: {
      CONVERSATIONS: '/chat/conversations',
      MESSAGES: '/chat/conversations/:id/messages',
      SEND_MESSAGE: '/chat/conversations/:id/messages',
      CREATE_CONVERSATION: '/chat/conversations',
      MARK_READ: '/chat/conversations/:id/read',
      SEARCH: '/chat/search',
    },
    
    // Reviews
    REVIEWS: {
      LIST: '/reviews',
      CREATE: '/reviews',
      GET: '/reviews/:id',
      UPDATE: '/reviews/:id',
      DELETE: '/reviews/:id',
      VERIFY: '/reviews/:id/verify',
      REPORT: '/reviews/:id/report',
      LAWYER_STATS: '/reviews/lawyer/:id/stats',
      ORG_STATS: '/reviews/organization/:id/stats',
      SEARCH: '/reviews/search',
    },
    
    // Proforma Quotations
    PROFORMA: {
      LIST: '/proforma',
      CREATE: '/proforma',
      GET: '/proforma/:id',
      UPDATE: '/proforma/:id',
      DELETE: '/proforma/:id',
      SEND: '/proforma/:id/send',
      ACCEPT: '/proforma/:id/accept',
      REJECT: '/proforma/:id/reject',
      PDF: '/proforma/:id/pdf',
    },
    
    // Organization
    ORGANIZATION: {
      GET: '/organization',
      UPDATE: '/organization',
      UPLOAD_LOGO: '/organization/logo',
    },
    
    // Tasks
    TASKS: {
      LIST: '/tasks/{user_id}',
      GET: '/tasks/task/{task_id}/{user_id}',
      CREATE: '/tasks',
      UPDATE: '/tasks/{task_id}',
      DELETE: '/tasks/{task_id}/{user_id}',
    },
    
    // Billing
    BILLING: {
      BILLS: '/billing/bills',
      REVENUES: '/billing/revenues',
      INVOICES: '/billing/invoices',
      PAYMENTS: '/billing/payments',
    },
  },
  
  // Request timeouts (in milliseconds)
  TIMEOUTS: {
    DEFAULT: 10000, // 10 seconds
    UPLOAD: 30000, // 30 seconds
    DOWNLOAD: 60000, // 1 minute
  },
  
  // Pagination defaults
  PAGINATION: {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
  },
  
  // File upload limits
  UPLOAD: {
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
  },
};

// Helper function to build URLs with parameters
export const buildUrl = (endpoint: string, params?: Record<string, any>): string => {
  if (!params) return endpoint;
  
  let url = endpoint;
  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, value);
  });
  
  return url;
};

// Helper function to build query strings
export const buildQueryString = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value.toString());
    }
  });
  return searchParams.toString();
};

export default BACKEND_CONFIG;
